/**
 * @fileoverview Tab navigation for My projects / Project library
 */

import { memo } from 'react'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'components'
import type { ProjectTab } from '../types'

interface ProjectsTabsProps {
  value: ProjectTab
  onChange: (value: ProjectTab) => void
  showTabs?: boolean
}

/**
 * Tab navigation between My projects and Project library.
 * Can be hidden for certain user profiles (e.g., students).
 */
export const ProjectsTabs: FC<ProjectsTabsProps> = memo(({ value, onChange, showTabs = true }) => {
  const { t } = useTranslation()

  const handleChange = (newValue: string | null) => {
    if (newValue === 'my' || newValue === 'library') {
      onChange(newValue)
    }
  }

  if (!showTabs) {
    return null
  }

  return (
    <Tabs value={value} onTabChange={handleChange}>
      <Tabs.List>
        <Tabs.Tab value="my">
          {t('arc_projects.tab_my')}
        </Tabs.Tab>
        <Tabs.Tab value="library">
          {t('arc_projects.tab_library')}
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  )
})

ProjectsTabs.displayName = 'ProjectsTabs'
